"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 9.4.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodDtoPgxEnum = exports.PaymentMethodDtoCellCultureEnum = exports.PaymentMethodDtoPrenatalDiagnosisCytoEnum = exports.PaymentMethodDtoParentalFollowupCytoEnum = exports.PaymentMethodDtoRecurrentPregnancyLossCytoEnum = exports.PaymentMethodDtoDevelopmentalDisordersCytoEnum = exports.PaymentMethodDtoPregnancyLossCytoEnum = exports.PaymentMethodDtoStatTatEnum = exports.PaymentMethodDtoSmaStatEnum = exports.PaymentMethodDtoProactiveEnum = exports.PaymentMethodDtoNipsEnum = exports.PaymentMethodDtoExomeEnum = exports.PaymentMethodDtoCarrierEnum = exports.PaymentMethodDtoDiagnosticEnum = void 0;
exports.PaymentMethodDtoDiagnosticEnum = {
    Institution: 'institution',
    Insurance: 'insurance',
    Patient: 'patient',
    NoCharge: 'no-charge'
};
exports.PaymentMethodDtoCarrierEnum = {
    Institution: 'institution',
    Insurance: 'insurance',
    Patient: 'patient',
    NoCharge: 'no-charge'
};
exports.PaymentMethodDtoExomeEnum = {
    Institution: 'institution',
    Insurance: 'insurance',
    Patient: 'patient',
    NoCharge: 'no-charge'
};
exports.PaymentMethodDtoNipsEnum = {
    Institution: 'institution',
    Insurance: 'insurance',
    Patient: 'patient',
    NoCharge: 'no-charge'
};
exports.PaymentMethodDtoProactiveEnum = {
    Institution: 'institution',
    Insurance: 'insurance',
    Patient: 'patient',
    NoCharge: 'no-charge'
};
exports.PaymentMethodDtoSmaStatEnum = {
    Institution: 'institution',
    Insurance: 'insurance',
    Patient: 'patient',
    NoCharge: 'no-charge'
};
exports.PaymentMethodDtoStatTatEnum = {
    Institution: 'institution',
    Insurance: 'insurance',
    Patient: 'patient',
    NoCharge: 'no-charge'
};
exports.PaymentMethodDtoPregnancyLossCytoEnum = {
    Institution: 'institution',
    Insurance: 'insurance',
    Patient: 'patient',
    NoCharge: 'no-charge'
};
exports.PaymentMethodDtoDevelopmentalDisordersCytoEnum = {
    Institution: 'institution',
    Insurance: 'insurance',
    Patient: 'patient',
    NoCharge: 'no-charge'
};
exports.PaymentMethodDtoRecurrentPregnancyLossCytoEnum = {
    Institution: 'institution',
    Insurance: 'insurance',
    Patient: 'patient',
    NoCharge: 'no-charge'
};
exports.PaymentMethodDtoParentalFollowupCytoEnum = {
    Institution: 'institution',
    Insurance: 'insurance',
    Patient: 'patient',
    NoCharge: 'no-charge'
};
exports.PaymentMethodDtoPrenatalDiagnosisCytoEnum = {
    Institution: 'institution',
    Insurance: 'insurance',
    Patient: 'patient',
    NoCharge: 'no-charge'
};
exports.PaymentMethodDtoCellCultureEnum = {
    Institution: 'institution',
    Insurance: 'insurance',
    Patient: 'patient',
    NoCharge: 'no-charge'
};
exports.PaymentMethodDtoPgxEnum = {
    Institution: 'institution',
    Insurance: 'insurance',
    Patient: 'patient',
    NoCharge: 'no-charge'
};
